import { render, staticRenderFns } from "./ESignature.vue?vue&type=template&id=452013e3&scoped=true"
import script from "./ESignature.vue?vue&type=script&lang=ts"
export * from "./ESignature.vue?vue&type=script&lang=ts"
import style0 from "./ESignature.vue?vue&type=style&index=0&id=452013e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452013e3",
  null
  
)

export default component.exports